module.exports = __webpack_public_path__ + "static/media/skiing.d2ff957e.svg";